import { TuneOutlined } from '@mui/icons-material';
import { useState } from 'react';

import { tCommon, tOrder } from '@frontend/locales';

import { IconActionButton } from '../icon-action-button.component';
import { OrderListSettingsDialog } from './order-list-settings-dialog.component';

export const OrderListSettingsAction = () => {
  const [toggleDialog, setToggleDialog] = useState(false);

  return (
    <>
      <IconActionButton
        onClick={() => setToggleDialog(!toggleDialog)}
        icon={<TuneOutlined />}
        title={tCommon.actions.settings()}
        ariaDescription={tOrder.descriptions.orderListSettings({
          action: toggleDialog
            ? tCommon.actions.close()
            : tCommon.actions.open(),
        })}
      />

      <OrderListSettingsDialog
        openState={toggleDialog}
        toggleDialog={setToggleDialog}
      />
    </>
  );
};
